export default __webpack_public_path__ + "static/media/Aboutbg1.5be50962.png";